import script from "./StudyAssistantDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudyAssistantDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./StudyAssistantDropdown.vue?vue&type=style&index=0&id=cb8a50dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb8a50dc"]])

export default __exports__